import React from "react";
import FormatDateTime from "../../../utils/formatDateTime";

const SignalUpdateTable = ({ signalData }) => {
  // Function to convert "rg" and "bb" values (from Regime table, kept as example but may not apply)
  const convertSignal = (signal) => {
      if (typeof signal === 'string') {
        return signal.replace(/r/g, "-1").replace(/g/g, "1").replace(/b/g, "0");
      }
      return signal;
  };

  if (!signalData || signalData.length === 0) {
      return (
        <div className="flex h-full w-full justify-center mt-10">
          <h3 className="flex items-center text-gray-300 text-md font-medium uppercase">
              No Data Present
          </h3>
        </div>
      );
  }

  // Define headers based on the first item in the array, customizing if necessary
  const headers = Object.keys(signalData[0]).filter(key => key !== 'message');

  // Function to generate table rows from array data
  const generateRows = (dataArray) => {
    return dataArray.map((item, index) => (
      <tr
        key={index}
        className="bg-black z-0 border-b last-of-type:border-b-0 border-gray-900 font-medium text-white hover:bg-black/90"
      >
        {headers.map((key, idx) => (
          <td
            key={idx}
            className={`${typeof item[key] === 'string' && item[key].includes("CE") ? "bg-emerald-700" : typeof item[key] === 'string' && item[key].includes("PE") ? "bg-rose-700" : "" } px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 whitespace-nowrap`}
          >
            {key === "time_stamp" || key === "last_updated"
              ? FormatDateTime(item[key]) // Format last_updated/timestamp data
              : key === "regime_signal"
              ? convertSignal(item[key]) // Convert "rg" and "bb"
              : item[key]}
          </td>
        ))}
      </tr>
    ));
  };


  return (
    <div className="w-full h-full overflow-auto relative rounded-md border border-gray-800">
        <table className="bg-black border-collapse text-sm w-full relative z-0 min-w-max">
            <thead className="bg-[#0F0F0F] text-sm text-left sticky top-0 z-10 shadow-md">
            <tr className="text-white border-b border-gray-800">
                {headers.map((header, idx) => (
                <th
                    key={idx}
                    className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold whitespace-nowrap"
                >
                    {header}
                </th>
                ))}
            </tr>
            </thead>
            <tbody>{generateRows(signalData)}</tbody>
        </table>
    </div>
  );
};

export default SignalUpdateTable;
